export default __webpack_public_path__ + "static/8-6aefc01e165466d2dc014f7e6b8f929e.png";